import React from "react";
import { money } from "./bundleText";

// The page bundles on sale as cards, each with its price, what a page comes to and
// how much it saves on printing page by page. The home page and /bundles show them.
const PlanCards = ({ plans, onBuy }) => (
  <div className="bnd-plans">
    {plans.map((plan) => {
      const saving =
        plan.regularPrice > plan.price ? Math.round((1 - plan.price / plan.regularPrice) * 100) : 0;
      return (
        <div key={plan.id} className={"bnd-plan" + (plan.shareable ? " is-team" : "")}>
          {plan.shareable && <span className="bnd-plan-flag">Багаараа</span>}
          <span className="bnd-plan-name">{plan.name}</span>
          {plan.description && <p className="bnd-plan-desc">{plan.description}</p>}
          <span className="bnd-plan-pages">
            {plan.pages}
            <small> хуудас</small>
          </span>
          <span className="bnd-plan-price">{money(plan.price)}</span>
          <span className="bnd-plan-unit">
            Хуудас {money(plan.pagePrice)}
            {saving > 0 && <span className="bnd-plan-save">−{saving}%</span>}
          </span>
          <ul className="bnd-plan-facts">
            <li>
              <i className="fas fa-calendar-alt" aria-hidden="true"></i>
              {plan.validityDays} хоногт хэрэглэнэ
            </li>
            {plan.shareable ? (
              <>
                <li>
                  <i className="fas fa-users" aria-hidden="true"></i>
                  {plan.maxPeople} хүн хүртэл, хүн бүр өөрийн бүртгэлээр
                </li>
                {plan.photoCredits > 0 && (
                  <li className="bnd-plan-gift">
                    <i className="fas fa-gift" aria-hidden="true"></i>
                    <span>
                      <b>Бэлэг:</b>{" "}
                      {plan.photoCredits >= plan.maxPeople
                        ? "багийн зургаа хүн бүр 10×15-аар үнэгүй"
                        : `багийн зураг ${plan.photoCredits} ширхэг 10×15 үнэгүй`}
                    </span>
                  </li>
                )}
                <li className="bnd-plan-gift">
                  <i className="fas fa-magic" aria-hidden="true"></i>
                  <span>Хүсвэл «Багуудын түүх»-д дурсамжаа үлдээнэ</span>
                </li>
              </>
            ) : (
              <li>
                <i className="fas fa-user" aria-hidden="true"></i>
                Өөрийн бүртгэлээр
              </li>
            )}
          </ul>
          <button type="button" className="button tpl-button is-fullwidth" onClick={() => onBuy(plan)}>
            Худалдаж авах
          </button>
        </div>
      );
    })}
  </div>
);

export default PlanCards;
